import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, PlayCircle } from 'lucide-react';

const WelcomeModal = ({ onClose }) => {
    // 모달이 열릴 때 배경 스크롤 비활성화
    useEffect(() => {
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';

        // cleanup 함수: 컴포넌트가 언마운트될 때 스크롤 복원
        return () => {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        };
    }, []);

    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={onClose}
            >
                <motion.div
                    className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 md:p-8 relative"
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.9, opacity: 0 }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* 닫기 버튼 */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    {/* 제목 */}
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 pr-8">
                        환영합니다 FC님!
                    </h2>

                    {/* 내용 */}
                    <div className="space-y-4 text-gray-700">
                        <p className="text-base md:text-lg leading-relaxed">
                            오른쪽 아래 보라색 + 버튼을 눌러 고객을 추가해보세요.
                        </p>

                        <ol className="space-y-3 text-sm md:text-base">
                            <li className="flex items-start gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-xs">
                                    1
                                </span>
                                <span className="pt-0.5">
                                    모든 고객 데이터는 외부로 전송되지 않으며, FC님의 기기에만 저장됩니다. 따라서 별도의 로그인 절차 없이 바로 사용가능합니다.
                                </span>
                            </li>
                            <li className="flex items-start gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-xs">
                                    2
                                </span>
                                <span className="pt-0.5">
                                    추가한 고객은<strong className="text-gray-900"> '가망고객'</strong>단계에 등록되며 각종 상담기록을 남길 수 있습니다.
                                </span>
                            </li>
                            <li className="flex items-start gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-xs">
                                    3
                                </span>
                                <span className="pt-0.5">
                                    고객정보에 도로명 주소를 입력했다면 오른쪽 위 <strong className="text-gray-900">파란색 지도 버튼</strong>을 눌러 카카오맵에서도 확인 가능합니다.
                                </span>
                            </li>
                            <li className="flex items-start gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-xs">
                                    4
                                </span>
                                <span className="pt-0.5">
                                    생일, 할 일(Follow Up)을 입력했다면 날짜에 맞춰 <strong className="text-gray-900">알림도 받을 수 있습니다</strong>.
                                </span>
                            </li>
                        </ol>
                    </div>

                    {/* 버튼 영역 */}
                    <div className="mt-8 flex justify-end gap-3">
                        <a
                            href="https://youtu.be/4M1woDa1Cbc?si=AHb8EjvJ3qP-rgaZ"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-6 py-2.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-semibold rounded-lg transition-all shadow-lg hover:shadow-xl flex items-center gap-2"
                        >
                            <PlayCircle className="w-5 h-5" />
                            가이드영상
                        </a>
                        <button
                            onClick={onClose}
                            className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors"
                        >
                            확인
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default WelcomeModal;

